import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let FullpageModalComp;

class FullpageModal extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: FullpageModalComp };  
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/fullpage-modal-comp" */
            "../../../components/javascript/zcat-components/fullpage-modal-comp"
        ).then(function(res) {
            FullpageModalComp = res.FullpageModalComp;
        }));

        
;
    }
}

export {FullpageModal};

